<template>
  <div class="fill_login">
    <div class="login_box">
      <div class="login_img">
        <img src="../assets/image/login/login.jpg">
      </div>
      <div class="ms-login">
        <div class="ms-title">
          <div class="system-logo">
            <img src='@/assets/image/home/logo.png'/>
            <span>重庆市住房和城乡建设委员会</span>
          </div>
          <div class="system-title"><span>重庆市配套费管理系统</span></div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
          <el-form-item prop="username">
            <el-input v-model="ruleForm.username" placeholder="用户名">
              <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" placeholder="密码" v-model="ruleForm.password" >
              <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
            </el-input>
          </el-form-item>
        <el-form-item prop="code">
            <div style="width:45%">
              <el-input id="inputCode"  placeholder="验证码" v-model="ruleForm.code"></el-input>
            </div>
            <img class="code" @click="getVerifyCode" :src="verifycode"/>
          </el-form-item>
          <div class="login-btn">
            <el-button type="primary" :loading="loading" @click="skip">登录</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div class="login_footer">
      <span>重庆市城市建设配套费管理办公室 市建设信息中心 电话63672019</span>
      <br/>
      <span>copyright 2009</span>
    </div>
  </div>
</template>
<script>
import axios from '@/utils/axios.js'
import {Decrypt,Encrypt} from '@/utils/crypto';
export default {
  name: "login",
  data: function(){
    return {
      verifycode : "",
      loading: false,
      ruleForm: {
        username: '',
        password: '',
        code:''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted(){
    this.getVerifyCode();
  },
  methods:{
    open(){
      this.$alert('登录失败，请重新登录！', '提示', {
        confirmButtonText: '确定'
      });
    },
    //  获取验证码
    getVerifyCode(){
     /* this.verifycode  = "http://jsgl.zfcxjw.cq.gov.cn:6016/base/captcha/verify?t=" + new Date();*/
      /*this.verifycode  = "http://172.30.41.57:8890/base/captcha/verify?t=" + new Date();*/
      /*this.verifycode  = "http://192.168.1.123:8890/base/captcha/verify?t=" + new Date();*/
      this.verifycode  = "/api/base/captcha/verify?t=" + new Date();

console.log(new Date())
      /* this.$http.post({

      }) */
      /* axios.post('/captcha/verify?t=' + new Date()).then(function(res){
        console.log(res);
        _this.verifycode = res.data;
      }) */
    },
    skip(){
      let _this = this;
      let param = {
        password : _this.$md5(_this.ruleForm.password),
        username : Encrypt(_this.ruleForm.username),
        verifycode : _this.ruleForm.code
      }
      axios.post('/base/login/login',param).then(function(res){
        let data = res.data.data;
        debugger
        if(data && data.i == 1){
          let sysInfo = data.account;
          sysInfo.session = data.sessionId;
          _this.$store.dispatch('setSystemInfo',sysInfo);
          if(sysInfo.role.id == "sp"){
            _this.$router.push('/check');
          }else{
            _this.$router.push('/fillout');
          }
        }else if(data && data.i == 0){
          _this.$alert('登录失败，用户名或密码错误！', '提示', {
            confirmButtonText: '确定'
          });
          //重新刷新验证码
          _this.ruleForm.code = "";
          _this. getVerifyCode();
        }else if(data && data.i == -1){
          _this.$alert('验证码错误，请重新输入！', '提示', {
            confirmButtonText: '确定'
          });
          _this.ruleForm.code = "";
          _this. getVerifyCode();
        }
      })

    }
  }

}
</script>
<style scoped>

  .fill_login{
    width: 100%;
    height:100%;
    position: absolute;
    left:0;
    top:0;
  }

  .login_box{
    width:80%;
    height:100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login_img,.ms-login{
    width:50%;
    height:40rem;
    float: left;
  }

  .login_img img{
    width:100%;
    height:100%;
  }

  .ms-login{
    background: #FFFFFF;
    box-shadow: 0 2px 8px 2px rgba(0,0,0,0.06);
  }

  .ms-login .ms-title{
    height:30%;
    display: flex;
    flex-direction: column;
    justify-content:flex-end;
    align-items: center;
  }

  .ms-login .ms-title .system-logo{
    display: flex;
    align-items: center;
    font-size: 1.8rem;
    font-weight: 550;
    color: #2372EA;
    line-height: 2.5rem;
    padding: 1rem 0;
  }

  .ms-login .ms-title .system-logo img{
    width:3.6rem;
    height:2.4rem;
    margin-right: 1rem;
  }

  .ms-login .ms-title .system-title{
    font-size: 2.4rem;
    color: #2372EA;
    font-weight: 550;
    line-height: 3.6rem;
    padding: 1rem 0;
  }

  .ms-content{
    width:60%;
    margin: 0 auto;
    margin-top:5rem;
  }

  .login-btn button{
    width: 100%;
  }
  .login_footer{
    width:100%;
    position: fixed;
    bottom: 2rem;
    text-align: center;
  }


  .login_footer span{
    font-size: 12px;
    color: rgba(0,0,0,0.45);
    line-height: 20px;
  }

  .code
  {
    /* font-family:Arial;
    font-style:italic;
    color:blue;
    font-size:30px;
    border:0;
    border-radius: 5px;
    padding:2px 3px;
    letter-spacing:3px;
    font-weight:bolder; */
    float:right;
    cursor:pointer;
    width:45%;
    height:37px;
    line-height:60px;/*
    text-align:center;
    vertical-align:middle;
    background-color:#E8F0FE; */
    margin-top:-40px;
  }


</style>






// WEBPACK FOOTER //
// src/views/login.vue